import React, { useState, useRef } from 'react';
import Widget from './Widget';

function Dashboard({ widgets, onOpenSettings, onDeleteWidget, onCloneWidget, onResizeWidget, onReorderWidgets, templateVars }) {
  const [dragId, setDragId] = useState(null);
  const dragOverId = useRef(null);

  if (!widgets || widgets.length === 0) {
    return (
      <div className="dashboard-empty">
        <h3>No saved widgets found</h3>
        <p>Switch to the Custom Metric Builder tab, run a query, and save it to your dashboard.</p>
      </div>
    );
  }

  const sorted = [...widgets].sort((a, b) => a.position - b.position);

  const handleDragStart = (id) => {
    setDragId(id);
  };

  const handleDragOver = (id) => {
    dragOverId.current = id;
  };

  const handleDrop = () => {
    const overId = dragOverId.current;
    if (dragId && overId && dragId !== overId && onReorderWidgets) {
      onReorderWidgets(dragId, overId);
    }
    setDragId(null);
    dragOverId.current = null;
  };

  return (
    <div className="dashboard-grid">
      {sorted.map(widget => (
        <Widget
          key={widget.id}
          widget={widget}
          onOpenSettings={onOpenSettings}
          onDelete={onDeleteWidget}
          onClone={onCloneWidget}
          onResize={onResizeWidget}
          templateVars={templateVars}
          onDragStart={handleDragStart}
          onDragOver={handleDragOver}
          onDrop={handleDrop}
        />
      ))}
    </div>
  );
}

export default Dashboard;
